export default __webpack_public_path__ + "static/media/ink.ebe75e9e.svg";